module.exports = __webpack_public_path__ + "static/media/image-overlay.79a406ef.png";